module.exports = __webpack_public_path__ + "static/media/5. Entre el agua, Óleo y resina cristal, 81 x 89 x 4 cm, 2020 copy.308e1e67.png";